// extracted by mini-css-extract-plugin
export default {"container":"WtJpB","iconWrapper":"CAQXu","image":"oprEw","iconImg":"ZehNB","text":"O37vU","viewCatalog":"pE8C2","viewDetail":"jxXmF","link":"M9BQ1","arrow":"guyhP"};